<template>
  <div class="app_container report-manage">
    <el-tabs v-model="activeTab">
        <el-tab-pane label="数据总览" name="1">
          <DataOverview @handleInfo="handleInfo"/>
        </el-tab-pane>
        <el-tab-pane label="报到详情" name="2">
          <ReportDetail ref="reportDetailRef" />
        </el-tab-pane>
      </el-tabs>
  </div>
</template>

<script>
import ReportDetail from './reportDetail.vue';
import DataOverview from './dataOverview.vue';
export default {
  name: "reportManage",
  components: { ReportDetail, DataOverview },
  data() {
    return {
      activeTab: '1',
    };
  },
  created() {
    
  },
  methods: {

    handleInfo(val) {
      this.activeTab = '2';
      this.$nextTick(() => {
        this.$refs.reportDetailRef.changeGroup(val.uuid);
      })
    }

  },
};
</script>
<style lang='scss' scoped>
.report-manage {
  padding: 24px;
}

/deep/ .el-tabs__item {
  font-size: 16px;
  color: #000;
}

/deep/ .el-tabs__item.is-active {
  font-size: 16px;
  color: #3a85ff;
}
</style>
